import { NgModule } from '@angular/core';
import { FieldToolsComponent } from './fieldtools';
import { CommonModule } from '@angular/common';
import { FieldsetModule } from 'primeng/fieldset';
import { VisibilityComponent } from "./visibility";
import {TranslateModule} from "@ngx-translate/core";
import {TooltipModule} from "primeng/tooltip";
import { DragDropModule } from 'primeng/dragdrop';

@NgModule({
    imports: [
        // import Angular's modules
        CommonModule,
        FieldsetModule,
        TranslateModule,
        TooltipModule,
        DragDropModule
    ],
    providers: [

    ],
    exports: [FieldToolsComponent, VisibilityComponent],
    declarations: [FieldToolsComponent, VisibilityComponent],
})
export class InternalModule {}
